export class Banner {
    constructor() {
        this.$form = $('.js-banner-form');
        this.$address = this.$form.find('input[name="zipcode"]');
        this.$subject = this.$form.find('select[name="subject"]');
        this.$submitBtn = this.$form.find('.js-banner-submit');

        this.$form.on('submit', (e) => this.onSubmitForm(e));
    }

    onSubmitForm(e) {
        e.preventDefault();
        const userCity = this.$address.val().trim();
        const userSubject = this.$subject.val();

        if ((userCity === '' && userSubject === 'none') || this.$submitBtn.prop('disabled') === true) return false;

        this.$submitBtn.append('<i class="fa fa-spin fa-spinner"></i>');
        this.$submitBtn.prop('disabled', true);

        // Stad en vak
        if (userSubject !== 'none' && userCity !== '') {
            this.getCities(userCity).then(closestCity => {
                const postLocation = closestCity === 'elders' ? '?location=' + userCity : '';
                const url = location.origin + userSubject + '/' + closestCity + postLocation;
                this.redirectTo(url);
            });
        } // Stad en geen vak
        else if (userSubject === 'none' && userCity !== '') {
            this.getCities(userCity).then(closestCity => {
                const postLocation = closestCity === 'elders' ? '?location=' + userCity : '';
                const url = location.origin + '/bijles/' + closestCity + postLocation;
                this.redirectTo(url);
            });
        } // Geen stad en maar wel vak
        else {
            const url = location.origin + userSubject;
            this.redirectTo(url);
        }
    }

    /**
     * Get the cities from the search service
     * @param city
     * @returns {*}
     */
    getCities(city) {
        return $.post(wp.ajaxurl, {
            action: 'edpress_action',
            service: 'SearchService',
            method: 'findCityForUserInput',
            ajax: true,
            nonce: wp.ajax_nonce,
            userInput: city
        });
    }

    /**
     * Redirects user
     * @param url
     */
    /* istanbul ignore next */
    redirectTo(url) {
        window.location.href = url;
    }
}
